import http from "./client";

interface IExistPhoneResponse {
  showNotify: boolean;
  days?: number;
}

export async function exist(): Promise<IExistPhoneResponse> {
  const response = await http.get('/api/profile/phone');
  return response.data;
}

interface ICheckPhoneResponse {
  retryTimeout: number;
}

export async function check(phone: string): Promise<ICheckPhoneResponse> {
  const response = await http.post('/api/profile/confirmphone', { 
    phone: phone 
  });
  return response.data;
}

export async function welcomeCheck(phone: string): Promise<ICheckPhoneResponse> {
  const response = await http.post('/api/profile/confirmwelcome', {
    phone: phone
  });
  return response.data;
}

interface IConfirmPhoneResponse {
  retryTimeout?: number;
}

export async function confirm(phone: string, code: string): Promise<IConfirmPhoneResponse> {
  const response = await http.post('/api/profile/confirmphone', {
    phone: phone,
    code: code,
  });
  return response.data;
}

export async function validate(phone: string): Promise<boolean> {
  const response = await http.get('/api/phones/validate', {
    params: {
      phone: phone
    }
  });
  return response.data;
}


const phones = {
  exist,
  check,
  welcomeCheck,
  confirm,
  validate
}

export default phones